import { useContext, useEffect, useState } from "react";
import CustomHeader from "../common/Header";
import { Button, Card, Skeleton } from "antd";
import { downloadCSV, formatDate, getUserRole } from "../../services/util";
import CustomTable from "../common/Table";
import { SettingContext } from "../../routes";
import { useQuery } from "react-query";
import HTTP from "../../services/httpService";

function FrontDeskConnection() {
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const { selectedDates, selectedHotels } = useContext(SettingContext);
    const [start_date, end_date] = selectedDates;
    const [tableData, setTableData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const hotel_ids = selectedHotels;

    const [sortedInfo, updateSortedInfo] = useState({
        order: "descend",
        columnKey: "hotel_staff_engaged_count",
    });
    const [formData, setFormData] = useState({
        start_date: formatDate(start_date),
        end_date: formatDate(end_date),
        page: 0,
        limit: 10,
        staff_id,
        hotel_ids,
        all_selected: hotel_ids.length > 0 ? false : true,
        sort_by: sortedInfo.columnKey,
        sorting: sortedInfo.order === "ascend" ? 2 : 1,
    });
    const {
        status: frontDeskConnectionStatus,
        data: frontDeskConnectionRes,
        refetch: getFrontDeskConnection,
    } = useQuery(
        "/front-desk-connection",
        async () => {
            return await HTTP("/dashboard/getStaffEngagedData", {
                ...formData,
            });
        },
        {
            enabled: false,
        },
    );

    useEffect(() => {
        getFrontDeskConnection();
    }, []);

    useEffect(() => {
        getFrontDeskConnection();
    }, [formData]);

    useEffect(() => {
        if (frontDeskConnectionStatus === "success") {
            const { data: tableData, total } = frontDeskConnectionRes;
            setTableData(tableData);
            setTotalRecords(total);
        }
    }, [frontDeskConnectionStatus, frontDeskConnectionRes]);

    function handleTableChange(pagination, _, sorter) {
        const { current, pageSize } = pagination;
        const { order, columnKey } = sorter;
        const others = {
            page: current - 1,
            limit: pageSize,
        };
        if (order !== undefined) {
            others.sorting = order === "ascend" ? 2 : 1;
            others.sort_by = columnKey;
            updateSortedInfo({ columnKey, order });
        } else {
            delete formData.sorting;
            delete formData.sort_by;
            updateSortedInfo({});
        }

        const newFormData = {
            ...formData,
            ...others,
        };

        setFormData(newFormData);
    }
    useEffect(() => {
        const hotel_ids = selectedHotels;
        setFormData({
            ...formData,
            hotel_ids,
            page: 0,
            all_selected: hotel_ids.length === 0 ? true : false,
        });
    }, [selectedHotels]);

    useEffect(() => {
        let [start_date, end_date] = selectedDates;
        start_date = formatDate(start_date);
        end_date = formatDate(end_date);
        setFormData({
            ...formData,
            start_date,
            page: 0,
            end_date,
        });
    }, [selectedDates]);

    const column = [
        {
            title: "Hotel",
            dataIndex: "hotel_name",
            key: "hotel_name",

            sorter: () => {},
            sortOrder:
                sortedInfo.columnKey === "hotel_name" ? sortedInfo.order : null,
        },
        {
            title: "Hotel Staff Engaged Count",
            dataIndex: "hotel_staff_engaged_count",
            key: "hotel_staff_engaged_count",
            sorter: () => {},
            sortOrder:
                sortedInfo.columnKey === "hotel_staff_engaged_count"
                    ? sortedInfo.order
                    : null,
        },
    ];

    async function downalodReport() {
        if (tableData.length === 0) {
            return;
        }
        const tempFormData = { ...formData };
        delete tempFormData["page"];
        delete tempFormData["limit"];

        const res = await HTTP("/dashboard/getStaffEngagedDataReport", {
            ...tempFormData,
        });
        downloadCSV(res, `Front_Desk_Connection_reports`);
    }

    return (
        <Card className="dashboard-container">
            <CustomHeader
                extraAfter={
                    (getUserRole() == "Super Admin" ||
                        getUserRole() == "Admin" ||
                        getUserRole() == "Management") && (
                        <Button
                            type="primary"
                            className="margin-right-5"
                            onClick={downalodReport}
                        >
                            Download
                        </Button>
                    )
                }
            />
            <Card className="box-shadow margin-10">
                {frontDeskConnectionStatus !== "loading" &&
                frontDeskConnectionStatus !== "idle" ? (
                    <CustomTable
                        columns={column}
                        tableData={tableData}
                        noOfrecords={totalRecords}
                        currentPage={formData.page + 1}
                        handleTableChange={handleTableChange}
                        className="likeDisLikeTable"
                        rowKey="id"
                    />
                ) : (
                    <Skeleton
                        active
                        title={false}
                        paragraph={{ rows: 20, width: 40 }}
                    />
                )}
            </Card>
        </Card>
    );
}

export { FrontDeskConnection };
